import { useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import { useLanguage } from '../context/LanguageContext'

function HeroSection() {
  const { t } = useLanguage()
  const [currentIndex, setCurrentIndex] = useState(0)
  const intervalRef = useRef(null)

  const slides = [
    {
      id: 'slide1',
      image: '/assets/downtown.jpg',
      heading: t('hero.slide1H'),
      description: t('hero.slide1P'),
      btnText: t('hero.slide1Btn'),
    },
    {
      id: 'slide2',
      image: '/assets/palmjumeira.jpg',
      heading: t('hero.slide2H'),
      description: t('hero.slide2P'),
      btnText: t('hero.slide2Btn'),
    },
    {
      id: 'slide3',
      image: '/assets/dubaimarina.jpg',
      heading: t('hero.slide3H'),
      description: t('hero.slide3P'),
      btnText: t('hero.slide3Btn'),
    },
    {
      id: 'slide4',
      image: '/assets/districtone.jpg',
      heading: t('hero.slide4H'),
      description: t('hero.slide4P'),
      btnText: t('hero.slide4Btn'),
    },
  ]

  const goTo = (index) => {
    setCurrentIndex(index)
    resetInterval()
  }

  const resetInterval = () => {
    if (intervalRef.current) clearInterval(intervalRef.current)
    intervalRef.current = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % slides.length)
    }, 5000)
  }

  useEffect(() => {
    resetInterval()
    return () => clearInterval(intervalRef.current)
  }, [])

  return (
    <div className="hero-container">
      <div className="left-section theme-blue" id="leftSection">
        {slides.map((slide, i) => (
          <div
            key={`content-${slide.id}`}
            className={`left-slide${i === currentIndex ? ' active' : ''}`}
            id={`content-${slide.id}`}
          >
            <div className="content-wrapper">
              <h1 className="hero-heading">{slide.heading}</h1>
              <p className="hero-description">{slide.description}</p>
              <Link to="/buy" className="hero-button">{slide.btnText}</Link>
            </div>
          </div>
        ))}
      </div>

      <div className="right-section">
        {slides.map((slide, i) => (
          <img
            key={`image-${slide.id}`}
            src={slide.image}
            alt="Luxury Property Location"
            className={`property-image${i === currentIndex ? ' active' : ''}`}
          />
        ))}
      </div>

      <div className="image-dots">
        {slides.map((_, i) => (
          <button
            key={i}
            className={`dot${i === currentIndex ? ' active' : ''}`}
            data-index={i}
            aria-label={`Go to slide ${i + 1}`}
            onClick={() => goTo(i)}
            style={{ border: 'none' }}
          />
        ))}
      </div>
    </div>
  )
}

export default HeroSection
